export { default, SwipeableViewsContext } from './SwipeableViews.js';